import { CloudUser } from 'projects/internal/r1-component-library/src/lib/models/appcloud/cloud-user.model';

export class UpdateCloudUserData {
    static readonly type = '[CloudUser] UpdateCloudUser';
    constructor(public cloudUser: CloudUser) {}
}
